(function () {
  var refreshTimer = null;
  var retryTimer = null;
  var refreshToken = 0;
  var activeController = null;
  var lastRenderedKey = '';
  var recommendationLimit = 4;
  var observerBound = false;
  var maxAnchorProducts = 3;
  var rulesConfig = null;
  var rulesConfigInflight = null;
  var prefetchInflight = new Map();
  var lastKnownRecsHeight = 0;
  var lastSuccessfulProducts = [];
  var lastSuccessfulCartKey = '';
  var renderingNow = false;
  var refreshRunning = false;
  var lastRefreshCartKey = '';
  var jsonCachePrefix = 'st_json_cache_v1:';
  var autoSlideTimer = null;
  var autoSlidePaused = false;
  var autoSlideListNode = null;
  var currentContext = null; // 'cart-drawer' | 'cart-page' | 'product-page'
  var recentlyShownKey = 'st_cart_reco_recent_v1';
  var recentlyShownTtlMs = 24 * 60 * 60 * 1000;

  function detectContext() {
    if (document.getElementById('CartPage-Recommendations')) return 'cart-page';
    if (window.ST_PRODUCT_RECO_DATA) return 'product-page';
    if (document.getElementById('CartDrawer-Recommendations')) return 'cart-drawer';
    return null;
  }

  function isEnabled() {
    return window.ST_CART_RECO_ENABLED === true;
  }

  function nowMs() {
    return Date.now ? Date.now() : new Date().getTime();
  }

  function getSessionJson(key, ttlMs) {
    try {
      var raw = window.sessionStorage.getItem(jsonCachePrefix + key);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || typeof parsed !== 'object') return null;
      if (!parsed.ts || !parsed.data) return null;
      if (ttlMs && nowMs() - Number(parsed.ts) > Number(ttlMs)) return null;
      return parsed.data;
    } catch (e) {
      return null;
    }
  }

  function setSessionJson(key, data) {
    try {
      window.sessionStorage.setItem(jsonCachePrefix + key, JSON.stringify({ ts: nowMs(), data: data }));
    } catch (e) {
      // ignore quota/private mode
    }
  }

  function getRecentlyShownMap() {
    try {
      var raw = window.sessionStorage.getItem(recentlyShownKey);
      var parsed = raw ? JSON.parse(raw) : {};
      if (!parsed || typeof parsed !== 'object') parsed = {};
      var now = nowMs();
      var changed = false;
      Object.keys(parsed).forEach(function (id) {
        var ts = Number(parsed[id]) || 0;
        if (!ts || now - ts > recentlyShownTtlMs) {
          delete parsed[id];
          changed = true;
        }
      });
      if (changed) {
        window.sessionStorage.setItem(recentlyShownKey, JSON.stringify(parsed));
      }
      return parsed;
    } catch (e) {
      return {};
    }
  }

  function markProductsRecentlyShown(products) {
    if (!Array.isArray(products) || !products.length) return;
    try {
      var map = getRecentlyShownMap();
      var now = nowMs();
      for (var i = 0; i < products.length; i += 1) {
        var id = products[i] && products[i].id != null ? String(products[i].id) : '';
        if (!id) continue;
        map[id] = now;
      }
      window.sessionStorage.setItem(recentlyShownKey, JSON.stringify(map));
    } catch (e) {
      // ignore storage failures
    }
  }

  function defaultRulesConfig() {
    return {
      ui: { mobileMaxWidthPx: 749, maxLinesDesktop: 4, maxLinesMobile: 3 },
      engine: { maxAnchors: 2, collectionFetchLimit: 60, maxPages: 2, requireAvailable: true },
      rules: [],
      // Safety default: never silently fall back to Shopify's algorithmic recommendations.
      // If rules can't load, we'll use family fallback collections instead.
      fallback: { collections: [], useShopifyRecommendations: false },
    };
  }

  function getRulesUrl() {
    return typeof window.ST_CART_RECO_RULES_URL === 'string' ? window.ST_CART_RECO_RULES_URL : '';
  }

  function ensureRulesConfig() {
    if (rulesConfig) return Promise.resolve(rulesConfig);
    if (rulesConfigInflight) return rulesConfigInflight;

    // Prefer inline rules config (injected by cart-drawer.liquid) so we don't depend on JSON fetch/CORS.
    try {
      if (window.ST_CART_RECO_RULES_INLINE && typeof window.ST_CART_RECO_RULES_INLINE === 'object') {
        var inlineCfg = window.ST_CART_RECO_RULES_INLINE;
        rulesConfig = Object.assign(defaultRulesConfig(), inlineCfg || {});
        rulesConfig.ui = Object.assign(defaultRulesConfig().ui, (inlineCfg && inlineCfg.ui) || {});
        rulesConfig.engine = Object.assign(defaultRulesConfig().engine, (inlineCfg && inlineCfg.engine) || {});
        rulesConfig.fallback = Object.assign(defaultRulesConfig().fallback, (inlineCfg && inlineCfg.fallback) || {});
        rulesConfig.rules = Array.isArray(inlineCfg && inlineCfg.rules) ? inlineCfg.rules : [];
        return Promise.resolve(rulesConfig);
      }
    } catch (e) {
      // ignore and continue to URL-based loading
    }

    var url = getRulesUrl();
    if (!url) {
      rulesConfig = defaultRulesConfig();
      return Promise.resolve(rulesConfig);
    }

    var cached = getSessionJson('rules:' + url, 30 * 60 * 1000);
    if (cached) {
      rulesConfig = Object.assign(defaultRulesConfig(), cached || {});
      rulesConfig.ui = Object.assign(defaultRulesConfig().ui, (cached && cached.ui) || {});
      rulesConfig.engine = Object.assign(defaultRulesConfig().engine, (cached && cached.engine) || {});
      rulesConfig.fallback = Object.assign(defaultRulesConfig().fallback, (cached && cached.fallback) || {});
      rulesConfig.rules = Array.isArray(cached && cached.rules) ? cached.rules : [];
      return Promise.resolve(rulesConfig);
    }

    rulesConfigInflight = fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('rules fetch failed');
        return r.json();
      })
      .then(function (cfg) {
        rulesConfigInflight = null;
        rulesConfig = Object.assign(defaultRulesConfig(), cfg || {});
        rulesConfig.ui = Object.assign(defaultRulesConfig().ui, (cfg && cfg.ui) || {});
        rulesConfig.engine = Object.assign(defaultRulesConfig().engine, (cfg && cfg.engine) || {});
        rulesConfig.fallback = Object.assign(defaultRulesConfig().fallback, (cfg && cfg.fallback) || {});
        rulesConfig.rules = Array.isArray(cfg && cfg.rules) ? cfg.rules : [];
        setSessionJson('rules:' + url, cfg || {});
        return rulesConfig;
      })
      .catch(function () {
        rulesConfigInflight = null;
        rulesConfig = defaultRulesConfig();
        return rulesConfig;
      });

    return rulesConfigInflight;
  }

  function isMobileViewport(cfg) {
    var maxW = (cfg && cfg.ui && Number(cfg.ui.mobileMaxWidthPx)) || 749;
    try {
      return window.matchMedia && window.matchMedia('(max-width: ' + String(maxW) + 'px)').matches;
    } catch (e) {
      return window.innerWidth <= maxW;
    }
  }

  function getMaxVisibleCartLines(cfg) {
    var ui = (cfg && cfg.ui) || defaultRulesConfig().ui;
    return isMobileViewport(cfg) ? Number(ui.maxLinesMobile || 2) : Number(ui.maxLinesDesktop || 3);
  }

  function getContainerId() {
    if (currentContext === 'cart-page') return 'CartPage-Recommendations';
    if (currentContext === 'product-page') return 'ProductPage-Recommendations';
    return 'CartDrawer-Recommendations';
  }

  function getContainer() {
    return document.getElementById(getContainerId());
  }

  function getListNode() {
    var container = getContainer();
    if (!container) return null;
    return container.querySelector('[data-recommendations-list]');
  }

  function getCacheKey(cartProductIds) {
    if (!cartProductIds || !cartProductIds.length) return '';
    var signature = cartProductIds.slice().sort().join(',');
    return 'st_cart_reco_v2:' + signature + ':limit=' + String(recommendationLimit);
  }

  function getPrefetchKey(productId) {
    return 'st_cart_reco_prefetch:' + String(productId);
  }

  function getCachedRecommendations(cacheKey) {
    if (!cacheKey) return [];
    try {
      var raw = window.sessionStorage.getItem(cacheKey);
      if (!raw) return [];
      var parsed = JSON.parse(raw);
      if (!Array.isArray(parsed)) return [];
      return parsed;
    } catch (e) {
      return [];
    }
  }

  function setCachedRecommendations(cacheKey, products) {
    if (!cacheKey || !products || !products.length) return;
    try {
      window.sessionStorage.setItem(cacheKey, JSON.stringify(products.slice(0, recommendationLimit)));
    } catch (e) {
      // Ignore storage failures (private mode / quota exceeded).
    }
  }

  function getPrefetchedRecommendationsForProduct(productId) {
    if (!productId) return [];
    try {
      var raw = window.sessionStorage.getItem(getPrefetchKey(productId));
      if (!raw) return [];
      var parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function setPrefetchedRecommendationsForProduct(productId, products) {
    if (!productId || !products || !products.length) return;
    try {
      window.sessionStorage.setItem(
        getPrefetchKey(productId),
        JSON.stringify(products.slice(0, recommendationLimit))
      );
    } catch (e) {
      // Ignore storage failures.
    }
  }

  function setLoadingState(isLoading) {
    var container = getContainer();
    var listNode = getListNode();
    if (!container || !listNode) return;

    if (isLoading) {
      container.classList.add('is-loading');
      container.hidden = false;
      var skeletons = '';
      var skelClass = currentContext === 'cart-drawer'
        ? 'cart-drawer-recommendation cart-drawer-recommendation--skeleton'
        : 'st-reco-card--skeleton';
      for (var i = 0; i < Math.min(recommendationLimit, 4); i += 1) {
        skeletons += '<div class="' + skelClass + '"></div>';
      }
      renderingNow = true;
      listNode.innerHTML = skeletons;
      renderingNow = false;
    } else {
      container.classList.remove('is-loading');
    }
  }

  function getDrawerLayoutNodes() {
    var inner = document.querySelector('cart-drawer .drawer__inner');
    var header = inner ? inner.querySelector('.drawer__header') : null;
    var footer = inner ? inner.querySelector('.drawer__footer') : null;
    var cartItemsRoot = document.getElementById('CartDrawer-CartItems');
    return { inner: inner, header: header, footer: footer, cartItemsRoot: cartItemsRoot };
  }

  function getCartItemsContentHeight(cartItemsRoot) {
    // The cart-drawer-items element is the scroll container (overflow:auto, flex:1).
    // It shrinks via flex to make room for recs + footer, and scrolls if items overflow.
    // We must use its clientHeight (visible/flex-allocated height), NOT the full content
    // height — otherwise 3 items look like they "need" 300px+ and the overlap check
    // incorrectly hides recs even though flex layout handles the space correctly.
    if (!cartItemsRoot) return 0;
    try {
      var scrollContainer = cartItemsRoot.closest('cart-drawer-items');
      if (scrollContainer) return scrollContainer.clientHeight || 0;
      return cartItemsRoot.clientHeight || 0;
    } catch (e) {
      return cartItemsRoot.clientHeight || 0;
    }
  }

  function isRecommendationsOverlappingItems() {
    // We intentionally do NOT compare against the last cart row's bounding box:
    // when the items region is scrollable, off-screen rows will still report a rect,
    // causing false positives (recs "flash then disappear").
    var container = getContainer();
    if (!container || container.hidden) return false;

    var nodes = getDrawerLayoutNodes();
    if (!nodes.inner || !nodes.header || !nodes.footer || !nodes.cartItemsRoot) return false;

    try {
      var innerH = nodes.inner.clientHeight || 0;
      var headerH = nodes.header.offsetHeight || 0;
      var footerH = nodes.footer.offsetHeight || 0;
      var available = innerH - headerH - footerH - 16;

      var itemsNeeded = getCartItemsContentHeight(nodes.cartItemsRoot);
      var recsNeeded = container.getBoundingClientRect().height || 0;

      // Slack to avoid jitter while the drawer animates.
      return itemsNeeded + recsNeeded > available + 36;
    } catch (e) {
      return false;
    }
  }

  function isDebugEnabled() {
    try {
      if (window.ST_CART_RECO_DEBUG === true) return true;
      var qs = String(window.location && window.location.search ? window.location.search : '');
      return qs.indexOf('st_reco_debug=1') !== -1;
    } catch (e) {
      return false;
    }
  }

  function debugLog() {
    if (!isDebugEnabled()) return;
    try {
      var args = Array.prototype.slice.call(arguments);
      args.unshift('[st-cart-reco]');
      // eslint-disable-next-line no-console
      console.log.apply(console, args);
    } catch (e) {
      // ignore
    }
  }

  function enforceNoOverlap(cartLineCount, maxLines) {
    // We only hide for overlap when we'd otherwise be showing recs.
    if (!cartLineCount || cartLineCount > maxLines) return;
    var container = getContainer();
    if (!container || container.hidden) return;
    try {
      if (isRecommendationsOverlappingItems()) {
        debugLog('hide: overlap', { cartLineCount: cartLineCount, maxLines: maxLines });
        container.hidden = true;
      }
    } catch (e) {
      // ignore
    }
  }

  function getStorefrontAccessToken() {
    try {
      var t = window.ST_STOREFRONT_ACCESS_TOKEN;
      t = t != null ? String(t) : '';
      t = t.trim();
      return t;
    } catch (e) {
      return '';
    }
  }

  function buildStorefrontGraphqlEndpoint() {
    // Use same-origin storefront endpoint so this works in preview and production without CORS.
    // Example: /api/2024-10/graphql.json
    var apiVersion = '2024-10';
    return '/api/' + apiVersion + '/graphql.json';
  }

  function updateLastKnownRecsHeight() {
    var container = getContainer();
    if (!container || container.hidden) return;
    try {
      var h = container.getBoundingClientRect().height;
      if (h && h > 0) lastKnownRecsHeight = h;
    } catch (e) {
      // ignore
    }
  }

  function shouldHideForViewport(cartLineCount, maxLines) {
    // Only applies when we'd otherwise show recs.
    if (!cartLineCount || cartLineCount > maxLines) return false;

    var container = getContainer();
    if (!container) return false;

    var nodes = getDrawerLayoutNodes();
    if (!nodes.inner || !nodes.header || !nodes.footer || !nodes.cartItemsRoot) return false;

    // Approx available space inside the drawer for items + recs.
    var innerH = nodes.inner.clientHeight || 0;
    var headerH = nodes.header.offsetHeight || 0;
    var footerH = nodes.footer.offsetHeight || 0;
    var available = innerH - headerH - footerH - 16; // small buffer

    // How tall the cart items want to be (full content), plus how tall recs would be.
    // Important: don't use cart-drawer-items.scrollHeight here. It's a flex child and its scrollHeight
    // can equal its own (large) clientHeight even when the cart contents are small, which would
    // incorrectly hide recommendations.
    var itemsNeeded = getCartItemsContentHeight(nodes.cartItemsRoot);
    var recsNeeded = 0;
    if (!container.hidden) {
      recsNeeded = container.getBoundingClientRect().height || 0;
    } else {
      // Use a cached height so we can still decide while hidden.
      recsNeeded = lastKnownRecsHeight || 210;
    }

    // Use hysteresis so we don't "flicker" hide/show while the drawer animates or images load.
    // If currently hidden, require more spare room to show.
    // If currently visible, tolerate mild overflow before hiding.
    var isHidden = !!container.hidden;
    if (isHidden) {
      return itemsNeeded + recsNeeded > available - 12;
    }
    return itemsNeeded + recsNeeded > available + 120;
  }

  function getCartProductIds() {
    var rows = document.querySelectorAll('#CartDrawer-CartItems [data-cart-product-id]');
    var ids = [];
    for (var i = 0; i < rows.length; i += 1) {
      var id = rows[i].getAttribute('data-cart-product-id');
      if (!id) continue;
      ids.push(String(id));
    }
    return Array.from(new Set(ids));
  }

  function getCartLineCount() {
    var rows = document.querySelectorAll('#CartDrawer-CartItems [data-cart-variant-id]');
    return rows.length;
  }

  function getCartProductTypes() {
    var rows = document.querySelectorAll('#CartDrawer-CartItems [data-cart-product-type]');
    var out = [];
    for (var i = 0; i < rows.length; i += 1) {
      var t = rows[i].getAttribute('data-cart-product-type') || '';
      t = String(t || '').trim();
      if (!t) continue;
      out.push(t);
    }
    return out;
  }

  function getCartProductTitles() {
    var rows = document.querySelectorAll('#CartDrawer-CartItems [data-cart-product-title]');
    var out = [];
    for (var i = 0; i < rows.length; i += 1) {
      var t = rows[i].getAttribute('data-cart-product-title') || '';
      t = String(t || '').trim();
      if (!t) continue;
      out.push(t);
    }
    return out;
  }

  function getCartProductHandles() {
    var rows = document.querySelectorAll('#CartDrawer-CartItems [data-cart-product-handle]');
    var out = [];
    for (var i = 0; i < rows.length; i += 1) {
      var h = rows[i].getAttribute('data-cart-product-handle') || '';
      h = String(h || '').trim();
      if (!h) continue;
      out.push(h);
    }
    return out;
  }

  function normalizeText(s) {
    return String(s || '').trim().toLowerCase();
  }

  function uniqueStrings(list) {
    var out = [];
    var seen = new Set();
    for (var i = 0; i < (list || []).length; i += 1) {
      var v = String(list[i] || '').trim();
      var k = normalizeText(v);
      if (!k || seen.has(k)) continue;
      seen.add(k);
      out.push(v);
    }
    return out;
  }

  function getCartFamilies(cartSignals) {
    var families = new Set();
    var list = Array.isArray(cartSignals) ? cartSignals : [];
    for (var i = 0; i < list.length; i += 1) {
      var t = normalizeText(list[i]);
      if (!t) continue;
      if (t.indexOf('guitar') !== -1 || t.indexOf('bass') !== -1) families.add('guitar');
      if (t.indexOf('drum') !== -1 || t.indexOf('cymbal') !== -1 || t.indexOf('percussion') !== -1) families.add('drums');
      if (t.indexOf('keyboard') !== -1 || t.indexOf('piano') !== -1 || t.indexOf('synth') !== -1 || t.indexOf('midi') !== -1)
        families.add('keys');
      if (t.indexOf('microphone') !== -1 || t.indexOf('mic') !== -1) families.add('mics');
      if (t.indexOf('speaker') !== -1 || t.indexOf('pa') !== -1 || t.indexOf('mixer') !== -1 || t.indexOf('live sound') !== -1)
        families.add('live');
      if (t.indexOf('amp') !== -1 || t.indexOf('amplifier') !== -1) families.add('amps');
    }
    return families;
  }

  function isAccessoryType(text) {
    var t = normalizeText(text);
    if (!t) return false;
    // Things we still want to recommend when an instrument is in-cart.
    var allow = [
      'strings',
      'cases',
      'bags',
      'straps',
      'picks',
      'capos',
      'tuners',
      'stands',
      'cables',
      'leads',
      'power adapters',
      'pedals',
      'benches',
      'covers',
      'heads',
      'sticks',
      'brushes',
      'mallets',
    ];
    for (var i = 0; i < allow.length; i += 1) {
      if (t.indexOf(allow[i]) !== -1) return true;
    }
    return false;
  }

  function isAccessoryOnlyCart(cartProductTypes) {
    var types = Array.isArray(cartProductTypes) ? cartProductTypes : [];
    if (!types.length) return false;
    for (var i = 0; i < types.length; i += 1) {
      if (!isAccessoryType(types[i])) return false;
    }
    return true;
  }

  function inferFamilyFromTitles(cartTitles) {
    var families = new Set();
    var titles = Array.isArray(cartTitles) ? cartTitles : [];
    for (var i = 0; i < titles.length; i += 1) {
      var t = normalizeText(titles[i]);
      if (!t) continue;
      if (t.indexOf('guitar') !== -1 || t.indexOf('bass') !== -1) families.add('guitar');
      if (t.indexOf('ukulele') !== -1 || t.indexOf('banjo') !== -1 || t.indexOf('mandolin') !== -1) families.add('guitar');
      if (t.indexOf('cello') !== -1 || t.indexOf('violin') !== -1 || t.indexOf('viola') !== -1) families.add('orchestral');
      if (t.indexOf('drum') !== -1 || t.indexOf('cymbal') !== -1 || t.indexOf('percussion') !== -1) families.add('drums');
      if (t.indexOf('keyboard') !== -1 || t.indexOf('piano') !== -1 || t.indexOf('synth') !== -1 || t.indexOf('midi') !== -1) families.add('keys');
      if (t.indexOf('microphone') !== -1 || t.indexOf('mic ') !== -1) families.add('mics');
      if (t.indexOf('speaker') !== -1 || t.indexOf('pa ') !== -1 || t.indexOf('mixer') !== -1) families.add('live');
      if (t.indexOf('amp') !== -1 || t.indexOf('amplifier') !== -1) families.add('amps');
    }
    return families;
  }

  function isInstrumentType(text, family) {
    var t = normalizeText(text);
    if (!t) return false;
    if (isAccessoryType(t)) return false;

    if (family === 'guitar') {
      return t.indexOf('guitar') !== -1 || t.indexOf('bass') !== -1;
    }
    if (family === 'drums') {
      return t.indexOf('drum') !== -1 || t.indexOf('cymbal') !== -1 || t.indexOf('percussion') !== -1;
    }
    if (family === 'keys') {
      return t.indexOf('keyboard') !== -1 || t.indexOf('piano') !== -1 || t.indexOf('synth') !== -1;
    }
    if (family === 'mics') {
      return t.indexOf('microphone') !== -1;
    }
    if (family === 'live') {
      return t.indexOf('speaker') !== -1 || t.indexOf('pa') !== -1 || t.indexOf('mixer') !== -1;
    }
    if (family === 'amps') {
      return t.indexOf('amp') !== -1 || t.indexOf('amplifier') !== -1;
    }
    return false;
  }

  function filterFallbackProductsByCart(cartSignals, products) {
    if (!products || !products.length) return [];
    var families = getCartFamilies(cartSignals);
    if (!families.size) return products;

    var out = [];
    for (var i = 0; i < products.length; i += 1) {
      var p = products[i];
      var pt = (p && (p.product_type || p.productType)) || '';
      var title = (p && p.title) || '';
      var shouldExclude = false;

      families.forEach(function (fam) {
        if (shouldExclude) return;
        if (isInstrumentType(pt, fam) || isInstrumentType(title, fam)) shouldExclude = true;
      });

      if (!shouldExclude) out.push(p);
    }
    return out;
  }

  function typeMatchesRule(productType, rule) {
    var match = rule && rule.match;
    if (!match) return false;
    var hay = normalizeText(productType);

    var equals = Array.isArray(match.productTypeEqualsAny) ? match.productTypeEqualsAny : [];
    for (var e = 0; e < equals.length; e += 1) {
      var eq = normalizeText(equals[e]);
      if (!eq) continue;
      if (hay === eq) return true;
    }

    var needles = Array.isArray(match.productTypeIncludesAny) ? match.productTypeIncludesAny : [];
    if (!needles.length) return false;
    for (var i = 0; i < needles.length; i += 1) {
      var n = normalizeText(needles[i]);
      if (!n) continue;
      if (hay.indexOf(n) !== -1) return true;
    }
    return false;
  }

  function setDrawerLineCountAttr(lineCount) {
    try {
      var drawerRoot = document.getElementById('CartDrawer');
      if (!drawerRoot) return;
      var safe = Math.max(0, Math.min(99, Number(lineCount) || 0));
      drawerRoot.setAttribute('data-st-cart-lines', String(safe));
    } catch (e) {
      // Best-effort only.
    }
  }

  async function fetchCartProductIdsFromApi(signal) {
    var response = await fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      signal: signal,
    });
    if (!response.ok) return [];
    var payload = await response.json().catch(function () {
      return { items: [] };
    });
    var items = Array.isArray(payload.items) ? payload.items : [];
    var ids = [];
    for (var i = 0; i < items.length; i += 1) {
      var id = items[i] && items[i].product_id != null ? String(items[i].product_id) : '';
      if (id) ids.push(id);
    }
    return Array.from(new Set(ids));
  }

  async function fetchCartSnapshotFromApi(signal) {
    var response = await fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      signal: signal,
    });
    if (!response.ok) return { productIds: [], lineCount: 0 };

    var payload = await response.json().catch(function () {
      return { items: [] };
    });
    var items = Array.isArray(payload.items) ? payload.items : [];
    var ids = [];
    var types = [];
    var titles = [];
    for (var i = 0; i < items.length; i += 1) {
      var id = items[i] && items[i].product_id != null ? String(items[i].product_id) : '';
      if (id) ids.push(id);
      // cart.js includes product_type per line item; use as a reliable fallback when the drawer DOM isn't ready yet.
      var pt = items[i] && items[i].product_type != null ? String(items[i].product_type) : '';
      pt = String(pt || '').trim();
      if (pt) types.push(pt);
      var title = items[i] && (items[i].product_title || items[i].title) != null ? String(items[i].product_title || items[i].title) : '';
      title = String(title || '').trim();
      if (title) titles.push(title);
    }
    return {
      productIds: Array.from(new Set(ids)),
      lineCount: items.length,
      productTypes: Array.from(new Set(types)),
      productTitles: Array.from(new Set(titles)),
    };
  }

  function formatPrice(cents) {
    var amount = Number(cents || 0) / 100;
    return new Intl.NumberFormat('en-AU', {
      style: 'currency',
      currency: 'AUD',
      minimumFractionDigits: 2,
    }).format(amount);
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/\"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function sanitizeProducts(products) {
    if (!Array.isArray(products)) return [];
    var out = [];
    for (var i = 0; i < products.length; i += 1) {
      var p = products[i];
      if (!p) continue;
      var id = p.id != null ? String(p.id) : '';
      var handle = p.handle != null ? String(p.handle) : '';
      var variants = p.variants || [];
      var variant0 = variants && variants[0] ? variants[0] : null;
      if (!id || !handle || !variant0 || !variant0.id) continue;
      out.push(p);
    }
    return out;
  }

  function getFamilyFallbackHandles(families) {
    // These are best-selling collections that are primarily add-ons, not instruments.
    // Keep lists short so we don't introduce lots of network latency on fallback.
    var f = families || new Set();
    var out = [];

    if (f.has('guitar')) {
      out = out.concat([
        'electric-guitar-strings',
        'acoustic-guitar-strings',
        'picks',
        'instrument-cables',
        'clip-on-tuners',
        'guitar-capos',
        'guitar-straps',
        'guitar-stands',
        'barstools',
      ]);
    }
    if (f.has('keys')) {
      out = out.concat(['keyboard-stands', 'benches', 'keyboard-pedals', 'power-adapters', 'headphones']);
    }
    if (f.has('drums')) {
      out = out.concat(['sticks-brushes-mallets', 'drum-stools', 'drum-heads', 'practice-pads', 'drum-cases-bags']);
    }
    if (f.has('mics')) {
      out = out.concat(['microphone-stands', 'microphone-cables', 'studio-cables-leads', 'headphones']);
    }
    if (f.has('live')) {
      out = out.concat(['cables-leads', 'speaker-cables', 'microphone-cables', 'di-boxes']);
    }
    if (f.has('amps')) {
      out = out.concat(['instrument-cables', 'amplifier-accessories', 'guitar-amp-cases-covers', 'bass-amp-cases-covers']);
    }
    if (f.has('orchestral')) {
      out = out.concat(['rosin', 'music-stands', 'violin-strings', 'cello-strings', 'violin-cases-bags', 'cello-cases-bags']);
    }

    // Dedupe while preserving order.
    var seen = new Set();
    var deduped = [];
    for (var i = 0; i < out.length; i += 1) {
      var h = normalizeText(out[i]);
      if (!h || seen.has(h)) continue;
      seen.add(h);
      deduped.push(h);
    }
    return deduped;
  }

  async function fetchFamilyFallbackRecommendations(cartProductIds, cartSignals, signal) {
    var families = getCartFamilies(cartSignals || []);
    if (!families.size) return [];

    var handles = getFamilyFallbackHandles(families);
    if (!handles.length) return [];

    var cartSet = new Set((cartProductIds || []).map(String));
    var out = [];
    var seen = new Set();

    // Keep this tight: 1 page per collection, and stop early.
    for (var i = 0; i < handles.length; i += 1) {
      if (out.length >= recommendationLimit) break;
      var h = handles[i];
      try {
        var list = await fetchProductsFromEndpoint('/collections/' + encodeURIComponent(h) + '/products.json', signal, 60, 1);
        for (var p = 0; p < list.length; p += 1) {
          if (out.length >= recommendationLimit) break;
          var prod = list[p];
          var id = String((prod && prod.id) || '');
          if (!id || seen.has(id) || cartSet.has(id)) continue;
          if (!isAvailable(prod)) continue;
          if (!prod.variants || !prod.variants.length) continue;
          var variantId = pickVariantId(prod);
          if (!variantId) continue;
          seen.add(id);
          out.push({
            id: prod.id,
            handle: prod.handle,
            title: prod.title,
            product_type: prod.product_type || '',
            available: isAvailable(prod),
            featured_image: pickImage(prod),
            variants: [{ id: Number(variantId), price: coerceMoneyCents(prod) / 100 }],
            price: coerceMoneyCents(prod),
          });
        }
      } catch (e) {
        // ignore
      }
    }

    // As a last safety, ensure we don't suggest an instrument from these collections.
    out = filterFallbackProductsByCart(cartSignals || [], out);
    return out.slice(0, recommendationLimit);
  }

  var PRODUCT_TYPE_CACHE_PREFIX = 'st_reco_product_type:';

  function getCachedProductTypeByHandle(handle) {
    try {
      if (!handle) return '';
      return String(sessionStorage.getItem(PRODUCT_TYPE_CACHE_PREFIX + normalizeText(handle)) || '');
    } catch (e) {
      return '';
    }
  }

  function setCachedProductTypeByHandle(handle, productType) {
    try {
      if (!handle || !productType) return;
      sessionStorage.setItem(PRODUCT_TYPE_CACHE_PREFIX + normalizeText(handle), String(productType));
    } catch (e) {
      // ignore
    }
  }

  async function fetchProductTypeByHandle(handle, signal) {
    if (!handle) return '';
    var cached = getCachedProductTypeByHandle(handle);
    if (cached) return cached;

    // This endpoint returns a full product object, including `type`.
    var res = await fetch('/products/' + encodeURIComponent(handle) + '.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      signal: signal,
    });
    if (!res.ok) return '';
    var payload = await res.json().catch(function () {
      return null;
    });
    var pt = payload && payload.type != null ? String(payload.type) : '';
    pt = String(pt || '').trim();
    if (pt) setCachedProductTypeByHandle(handle, pt);
    return pt;
  }

  async function hydrateMissingProductTypes(products, cartSignals, signal) {
    if (!products || !products.length) return products || [];
    var families = getCartFamilies(cartSignals || []);
    if (!families.size) return products;

    // Only pay this cost when an in-cart instrument family exists and the candidate lacks product_type.
    var needsHydrate = false;
    for (var i = 0; i < products.length; i += 1) {
      var p = products[i];
      var pt = (p && (p.product_type || p.productType)) || '';
      if (!String(pt || '').trim()) {
        needsHydrate = true;
        break;
      }
    }
    if (!needsHydrate) return products;

    // Keep this fast: hydrate only a small window of candidates, and cache results.
    var maxHydrate = 12;
    var pending = [];
    var index = [];
    for (var j = 0; j < products.length && pending.length < maxHydrate; j += 1) {
      var prod = products[j];
      if (!prod || !prod.handle) continue;
      var existing = String((prod.product_type || prod.productType) || '').trim();
      if (existing) continue;
      pending.push(fetchProductTypeByHandle(String(prod.handle), signal));
      index.push(j);
    }

    if (!pending.length) return products;

    var settled = await Promise.allSettled(pending);
    for (var k = 0; k < settled.length; k += 1) {
      if (settled[k].status !== 'fulfilled') continue;
      var pt2 = String(settled[k].value || '').trim();
      if (!pt2) continue;
      var idx = index[k];
      if (!products[idx]) continue;
      products[idx].product_type = products[idx].product_type || pt2;
    }

    return products;
  }

  async function hydrateCartProductTypesFromHandles(cartProductTypes, handles, signal) {
    var types = uniqueStrings(cartProductTypes || []);
    if (types.length) return types;
    var hs = Array.isArray(handles) ? handles : [];
    if (!hs.length) return types;

    // Cart drawer typically has 1-3 items; keep it bounded.
    var max = Math.min(3, hs.length);
    var pending = [];
    for (var i = 0; i < max; i += 1) {
      pending.push(fetchProductTypeByHandle(String(hs[i] || ''), signal));
    }
    var settled = await Promise.allSettled(pending);
    for (var j = 0; j < settled.length; j += 1) {
      if (settled[j].status !== 'fulfilled') continue;
      var pt = String(settled[j].value || '').trim();
      if (pt) types.push(pt);
    }
    return uniqueStrings(types);
  }

  async function fetchRecommendationsForProduct(productId, signal) {
    var intents = ['complementary', 'related'];
    var merged = [];
    var seen = new Set();
    var responses = await Promise.all(
      intents.map(async function (intent) {
        var url =
          '/recommendations/products.json?product_id=' +
          encodeURIComponent(productId) +
          '&limit=' + encodeURIComponent(String(Math.max(4, recommendationLimit))) + '&intent=' +
          encodeURIComponent(intent);

        try {
          var response = await fetch(url, {
            credentials: 'same-origin',
            headers: { Accept: 'application/json' },
            signal: signal,
          });
          if (!response.ok) return [];
          var payload = await response.json().catch(function () {
            return { products: [] };
          });
          return payload.products || [];
        } catch (e) {
          if (e && e.name === 'AbortError') throw e;
          return [];
        }
      })
    );

    for (var i = 0; i < responses.length; i += 1) {
      var products = responses[i];
      for (var p = 0; p < products.length; p += 1) {
        var id = String(products[p].id || '');
        if (!id || seen.has(id)) continue;
        seen.add(id);
        merged.push(products[p]);
      }
    }

    return merged;
  }

  async function fetchProductsFromEndpoint(basePath, signal, pageSize, maxPages) {
    var products = [];
    var size = Math.max(24, Math.min(250, Number(pageSize) || 50));
    var pages = Math.max(1, Math.min(8, Number(maxPages) || 1));

    var cacheKey = 'products:' + basePath + ':limit=' + String(size) + ':pages=' + String(pages);
    var cached = getSessionJson(cacheKey, 2 * 60 * 60 * 1000);
    if (cached && Array.isArray(cached)) return cached;

    for (var page = 1; page <= pages; page += 1) {
      var joiner = basePath.indexOf('?') === -1 ? '?' : '&';
      var url =
        basePath +
        joiner +
        'limit=' +
        encodeURIComponent(String(size)) +
        '&page=' +
        encodeURIComponent(String(page));
      var response = await fetch(url, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
        signal: signal,
      });
      if (!response.ok) break;

      var payload = await response.json().catch(function () {
        return { products: [] };
      });
      var pageProducts = Array.isArray(payload.products) ? payload.products : [];
      if (!pageProducts.length) break;

      for (var i = 0; i < pageProducts.length; i += 1) {
        products.push(pageProducts[i]);
      }

      if (pageProducts.length < size) break;
    }

    if (products.length) setSessionJson(cacheKey, products);
    return products;
  }

  function isAvailable(product) {
    if (!product) return false;
    if (typeof product.available === 'boolean') return product.available;
    var variants = product.variants || [];
    for (var i = 0; i < variants.length; i += 1) {
      if (variants[i] && variants[i].available) return true;
    }
    return false;
  }

  function pickVariantId(product) {
    var variants = (product && product.variants) || [];
    if (!variants.length) return '';
    for (var i = 0; i < variants.length; i += 1) {
      var v = variants[i];
      if (!v) continue;
      if (v.available === false) continue;
      return String(v.id || '');
    }
    return String(variants[0].id || '');
  }

  function pickImage(product) {
    if (!product) return '';
    var fi = product.featured_image;
    if (fi) return typeof fi === 'string' ? fi : (fi.src || '');
    if (product.images && product.images.length) {
      var img = product.images[0];
      return typeof img === 'string' ? img : (img && img.src) || '';
    }
    return '';
  }

  function coerceMoneyCents(product) {
    // Shopify products.json usually provides price as string dollars, not cents.
    var p = product && product.variants && product.variants[0] && product.variants[0].price;
    var n = Number(p);
    if (!Number.isFinite(n)) n = Number(product && product.price);
    if (!Number.isFinite(n)) return 0;
    return Math.round(n * 100);
  }

  async function fetchSalesRanksForProductIds(productIds, signal) {
    var token = getStorefrontAccessToken();
    if (!token) return new Map();
    var ids = Array.isArray(productIds) ? productIds : [];
    if (!ids.length) return new Map();

    // Storefront API nodes query: chunk to keep payload reasonable.
    var out = new Map();
    var endpoint = buildStorefrontGraphqlEndpoint();

    for (var i = 0; i < ids.length; i += 80) {
      var slice = ids.slice(i, i + 80);
      var gidSlice = slice
        .map(function (id) {
          var n = String(id || '').trim();
          if (!n) return '';
          // If already a gid, keep it.
          if (n.indexOf('gid://') === 0) return n;
          return 'gid://shopify/Product/' + n;
        })
        .filter(Boolean);

      if (!gidSlice.length) continue;

      var query =
        'query($ids:[ID!]!) {' +
        '  nodes(ids:$ids) {' +
        '    ... on Product {' +
        '      id' +
        '      metafield(namespace:\"soundtrap\", key:\"sales_rank\") { value }' +
        '    }' +
        '  }' +
        '}';

      var res = await fetch(endpoint, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Shopify-Storefront-Access-Token': token,
        },
        body: JSON.stringify({ query: query, variables: { ids: gidSlice } }),
        signal: signal,
      });
      if (!res.ok) {
        debugLog('storefront rank fetch failed', { status: res.status });
        continue;
      }
      var payload = await res.json().catch(function () {
        return null;
      });
      var nodes = payload && payload.data && Array.isArray(payload.data.nodes) ? payload.data.nodes : [];
      for (var nIdx = 0; nIdx < nodes.length; nIdx += 1) {
        var node = nodes[nIdx];
        if (!node || !node.id) continue;
        var gid = String(node.id);
        var parts = gid.split('/');
        var numericId = parts && parts.length ? parts[parts.length - 1] : '';
        // Only treat as hydrated when the metafield exists and is a valid number.
        // Many products will return `metafield: null` unless the metafield definition is Storefront-accessible.
        var raw = node.metafield && node.metafield.value != null ? String(node.metafield.value) : '';
        if (!raw) continue;
        var rank = Number(raw);
        if (!Number.isFinite(rank) || rank <= 0) continue;
        if (numericId) out.set(String(numericId), rank);
      }
    }

    return out;
  }

  function parsePickPackSizeFromTitle(title) {
    var t = String(title || '');
    var m = t.match(/(?:^|\\b)(\\d{1,3})\\s*(?:-\\s*)?(?:pack|pk|pcs|picks)\\b/i);
    if (m && m[1]) return Number(m[1]) || 0;
    return 0;
  }

  // Normalize collection handles to a smaller set of "addon categories" so the cart drawer
  // shows variety (strings + picks + cable + tuner) rather than 4 items from the same area.
  function addonCategoryForCollectionHandle(handle) {
    var h = normalizeText(handle);
    if (!h) return 'other';
    if (h.indexOf('strings') !== -1) return 'strings';
    if (h.indexOf('reed') !== -1 || h.indexOf('reeds') !== -1) return 'reeds';
    if (h.indexOf('picks') !== -1) return 'picks';
    if (h.indexOf('cable') !== -1 || h.indexOf('lead') !== -1) return 'cables';
    if (h.indexOf('tuner') !== -1) return 'tuners';
    if (h.indexOf('capo') !== -1) return 'capos';
    if (h.indexOf('strap') !== -1) return 'straps';
    if (h.indexOf('stand') !== -1) return 'stands';
    if (h.indexOf('case') !== -1 || h.indexOf('bag') !== -1 || h.indexOf('cover') !== -1) return 'cases_bags';
    if (h.indexOf('stool') !== -1 || h.indexOf('barstool') !== -1 || h.indexOf('bench') !== -1) return 'seats';
    if (
      h.indexOf('care') !== -1 ||
      h.indexOf('clean') !== -1 ||
      h.indexOf('polish') !== -1 ||
      h.indexOf('mainten') !== -1 ||
      h.indexOf('condition') !== -1 ||
      h.indexOf('oil') !== -1
    ) return 'care';
    return 'other';
  }

  function shuffleArray(arr, startIndex) {
    // Fisher-Yates shuffle from startIndex onwards; items before startIndex stay pinned.
    var start = Number(startIndex) || 0;
    for (var i = arr.length - 1; i > start; i -= 1) {
      var j = start + Math.floor(Math.random() * (i - start + 1));
      var tmp = arr[i];
      arr[i] = arr[j];
      arr[j] = tmp;
    }
    return arr;
  }

  function addonCategoryPriority(category) {
    // Default priority for guitars and most instruments: "core add-ons" first.
    // Lower number = earlier.
    var c = String(category || '');
    if (c === 'strings') return 10;
    if (c === 'reeds') return 15;
    if (c === 'picks') return 20;
    if (c === 'cables') return 30;
    if (c === 'tuners') return 40;
    if (c === 'capos') return 50;
    if (c === 'straps') return 60;
    if (c === 'stands') return 70;
    if (c === 'cases_bags') return 80;
    if (c === 'care') return 85;
    if (c === 'seats') return 90;
    return 200;
  }

  function addonSlotForCategory(category) {
    var c = String(category || '');
    if (c === 'strings' || c === 'reeds' || c === 'picks' || c === 'cables' || c === 'tuners' || c === 'capos') {
      return 'core';
    }
    if (c === 'straps' || c === 'stands') {
      return 'utility';
    }
    if (c === 'cases_bags' || c === 'seats' || c === 'care') {
      return 'margin';
    }
    return 'utility';
  }

  function buildSlotPlan(limit) {
    var n = Math.max(1, Number(limit) || recommendationLimit || 4);
    if (n >= 4) return ['core', 'utility', 'margin', 'wildcard'];
    if (n === 3) return ['core', 'utility', 'margin'];
    if (n === 2) return ['core', 'utility'];
    return ['core'];
  }

  function orderCollectionSpecsForSlots(specs, limit) {
    var input = Array.isArray(specs) ? specs.slice() : [];
    if (!input.length) return [];

    var bySlot = { core: [], utility: [], margin: [] };
    var i;
    for (i = 0; i < input.length; i += 1) {
      var spec = input[i];
      var slot = addonSlotForCategory(spec && spec.category);
      if (!bySlot[slot]) bySlot[slot] = [];
      bySlot[slot].push(spec);
    }
    Object.keys(bySlot).forEach(function (slotKey) {
      bySlot[slotKey].sort(function (a, b) {
        return addonCategoryPriority(a.category) - addonCategoryPriority(b.category);
      });
      // Keep a sensible ordering bias, but vary position to avoid repetitive outputs.
      shuffleArray(bySlot[slotKey], 0);
    });

    var plan = buildSlotPlan(limit);
    var picked = [];
    var usedHandles = new Set();
    var fallbackOrder = ['core', 'utility', 'margin'];

    function pickFromSlot(slotKey) {
      var arr = bySlot[slotKey] || [];
      while (arr.length) {
        var candidate = arr.shift();
        var handle = String((candidate && candidate.handle) || '');
        if (!handle || usedHandles.has(handle)) continue;
        usedHandles.add(handle);
        return candidate;
      }
      return null;
    }

    for (i = 0; i < plan.length; i += 1) {
      var want = plan[i];
      var chosen = null;
      if (want !== 'wildcard') {
        chosen = pickFromSlot(want);
      }
      if (!chosen) {
        for (var f = 0; f < fallbackOrder.length && !chosen; f += 1) {
          chosen = pickFromSlot(fallbackOrder[f]);
        }
      }
      if (chosen) picked.push(chosen);
    }

    // Append any remaining collections (still deduped) as overflow candidates.
    for (i = 0; i < fallbackOrder.length; i += 1) {
      var rest = bySlot[fallbackOrder[i]] || [];
      for (var r = 0; r < rest.length; r += 1) {
        var extra = rest[r];
        var extraHandle = String((extra && extra.handle) || '');
        if (!extraHandle || usedHandles.has(extraHandle)) continue;
        usedHandles.add(extraHandle);
        picked.push(extra);
      }
    }
    return picked;
  }

  function isLikelySingle(title) {
    var t = normalizeText(title);
    if (!t) return false;
    if (t.indexOf('single string') !== -1) return true;
    if (t.indexOf('(single)') !== -1) return true;
    return false;
  }

  function parseStringCountFromTitle(title) {
    var t = String(title || '');
    var m = t.match(/\b([78])\s*[-]?\s*[Ss]tring/);
    if (m && m[1]) return Number(m[1]) || 0;
    return 0;
  }

  function cartNeedsExtendedRange(cartProductTypes) {
    var types = Array.isArray(cartProductTypes) ? cartProductTypes : [];
    for (var i = 0; i < types.length; i += 1) {
      var t = normalizeText(types[i]);
      if (/\b7\s*[-]?\s*string/i.test(t)) return 7;
      if (/\b8\s*[-]?\s*string/i.test(t)) return 8;
    }
    return 0;
  }

  function extractCompatibilityModels(title) {
    var t = String(title || '');
    var m = t.match(/\b(?:for|fits|suits|compatible\s+with)\s+(.+)/i);
    if (!m || !m[1]) return [];
    // Split on common delimiters and keep only tokens containing at least one digit
    // (distinguishes model numbers like "CDP-S160" from generic words like "Guitar").
    var raw = m[1].split(/[,\/&]+/);
    var models = [];
    for (var i = 0; i < raw.length; i += 1) {
      var token = String(raw[i] || '').trim();
      if (!token) continue;
      if (!/\d/.test(token)) continue;
      models.push(token.toLowerCase());
    }
    return models;
  }

  function cartContainsAnyModel(models, cartTitles, cartHandles) {
    if (!models || !models.length) return true;
    var haystack = [];
    var i;
    for (i = 0; i < (cartTitles || []).length; i += 1) {
      haystack.push(normalizeText(cartTitles[i]));
    }
    for (i = 0; i < (cartHandles || []).length; i += 1) {
      haystack.push(normalizeText(cartHandles[i]));
    }
    var joined = haystack.join(' ');
    for (i = 0; i < models.length; i += 1) {
      if (joined.indexOf(models[i]) !== -1) return true;
    }
    return false;
  }

  function weightedRandomPick(candidates) {
    // candidates: [{product, score}, ...] sorted desc by score.
    if (!candidates.length) return null;
    if (candidates.length === 1) return candidates[0].product;

    // Shift scores to positive range (min becomes 1).
    var minScore = candidates[candidates.length - 1].score;
    var shift = minScore < 1 ? 1 - minScore : 0;
    var totalWeight = 0;
    for (var i = 0; i < candidates.length; i += 1) {
      totalWeight += candidates[i].score + shift;
    }
    if (totalWeight <= 0) return candidates[0].product;

    var rand = Math.random() * totalWeight;
    var cumulative = 0;
    for (var j = 0; j < candidates.length; j += 1) {
      cumulative += candidates[j].score + shift;
      if (rand <= cumulative) return candidates[j].product;
    }
    return candidates[0].product;
  }

  function pickBestCandidateFromCollection(handle, products, cartSet, seen, requireAvailable, cartProductTypes, cartTitles, cartHandles, recentShownMap) {
    var h = normalizeText(handle);
    var candidates = [];
    for (var i = 0; i < products.length; i += 1) {
      var prod = products[i];
      var id = String((prod && prod.id) || '');
      if (!id || seen.has(id) || cartSet.has(id)) continue;
      if (requireAvailable && !isAvailable(prod)) continue;
      if (!prod.variants || !prod.variants.length) continue;
      var variantId = pickVariantId(prod);
      if (!variantId) continue;

      // Base score prefers early items (collection ordering should be best-sellers/featured).
      var score = 1000 - i;

      // Prefer high sales_rank when present. sales_rank is a positive composite score where higher is "more popular".
      // Use log scaling so it influences selection without completely dominating other heuristics.
      var sr = Number((prod && prod.sales_rank) || 0);
      if (!Number.isFinite(sr)) sr = 0;
      if (sr > 0) {
        score += Math.log10(sr + 1) * 5000;
      }

      // Picks: prefer 10+ packs when possible.
      if (h === 'picks' || h.indexOf('picks') !== -1) {
        var pack = parsePickPackSizeFromTitle(prod.title);
        if (pack >= 10) score += 700 + Math.min(pack, 100);
        // Thumb picks are only relevant for acoustic guitars; penalize for electric/classical/other.
        var ptLower = normalizeText(prod.title);
        if (ptLower.indexOf('thumb pick') !== -1 || ptLower.indexOf('thumb pk') !== -1 || ptLower.indexOf('thumbpick') !== -1) {
          var hasAcoustic = false;
          for (var ct = 0; ct < (cartProductTypes || []).length; ct += 1) {
            var cpt = normalizeText(cartProductTypes[ct]);
            if (cpt.indexOf('acoustic') !== -1 && cpt.indexOf('classical') === -1) { hasAcoustic = true; break; }
          }
          if (!hasAcoustic) {
            for (var cti = 0; cti < (cartTitles || []).length; cti += 1) {
              var ctl = normalizeText(cartTitles[cti]);
              if (ctl.indexOf('acoustic') !== -1 && ctl.indexOf('classical') === -1) { hasAcoustic = true; break; }
            }
          }
          if (!hasAcoustic) score -= 15000;
        }
      }

      // Strings: avoid obvious singles.
      if (h.indexOf('strings') !== -1) {
        if (isLikelySingle(prod.title)) score -= 800;
        // Penalize 7/8-string sets when cart has standard (6-string) guitar.
        var prodStringCount = parseStringCountFromTitle(prod.title);
        var cartStringCount = cartNeedsExtendedRange(cartProductTypes || []);
        if (prodStringCount > 0 && cartStringCount === 0) {
          score -= 50000;
        }
      }

      // Penalize products naming specific compatible models that don't match anything in cart.
      var compatModels = extractCompatibilityModels(prod.title);
      if (compatModels.length > 0 && !cartContainsAnyModel(compatModels, cartTitles, cartHandles)) {
        score -= 25000;
      }

      candidates.push({ product: prod, score: score });
    }

    if (!candidates.length) return null;

    // Sort desc by score, then pick weighted-random from top window for variety.
    candidates.sort(function (a, b) { return b.score - a.score; });
    var fresh = [];
    var stale = [];
    for (var ci = 0; ci < candidates.length; ci += 1) {
      var cProd = candidates[ci] && candidates[ci].product;
      var cId = cProd && cProd.id != null ? String(cProd.id) : '';
      if (cId && recentShownMap && recentShownMap[cId]) stale.push(candidates[ci]);
      else fresh.push(candidates[ci]);
    }
    var pool = fresh.length ? fresh : stale;
    pool = pool.slice(0, 8);
    return weightedRandomPick(pool);
  }

  async function getRuleBasedRecommendations(cfg, cartProductIds, cartProductTypes, signal, cartTitles, cartHandles) {
    var engine = (cfg && cfg.engine) || defaultRulesConfig().engine;
    var rules = Array.isArray(cfg && cfg.rules) ? cfg.rules : [];

    var maxAnchors = Math.max(1, Math.min(4, Number(engine.maxAnchors) || 2));
    var seenTypes = new Set();
    var anchors = [];
    for (var i = 0; i < cartProductTypes.length; i += 1) {
      var t = String(cartProductTypes[i] || '');
      var key = normalizeText(t);
      if (!key || seenTypes.has(key)) continue;
      seenTypes.add(key);
      anchors.push(t);
      if (anchors.length >= maxAnchors) break;
    }
    if (!anchors.length) return [];

    // Build ordered collection list from matching rules.
    var collectionSpecs = [];
    var seenHandles = new Set();
    var seenCategories = new Set();
    for (var a = 0; a < anchors.length; a += 1) {
      var matched = null;
      for (var r = 0; r < rules.length; r += 1) {
        if (typeMatchesRule(anchors[a], rules[r])) {
          matched = rules[r];
          break;
        }
      }
      if (!matched) continue;
      debugLog('rule match', { anchorType: anchors[a], ruleId: matched.id || '(no id)' });
      var rec = matched.recommend || {};
      var cols = Array.isArray(rec.collections) ? rec.collections : [];
      for (var c = 0; c < cols.length; c += 1) {
        var handle = cols[c] && cols[c].handle ? String(cols[c].handle) : '';
        handle = normalizeText(handle);
        if (!handle || seenHandles.has(handle)) continue;
        // Enforce diversity at the "addon category" level (strings/picks/cables/etc).
        // This prevents multiple string collections from consuming all rec slots.
        var cat = addonCategoryForCollectionHandle(handle);
        if (seenCategories.has(cat)) continue;
        seenCategories.add(cat);
        seenHandles.add(handle);
        collectionSpecs.push({
          handle: handle,
          category: cat,
          limit: Math.max(12, Math.min(250, Number(cols[c].limit) || Number(engine.collectionFetchLimit) || 60)),
        });
      }
    }

    if (!collectionSpecs.length) return [];
    // Keep queries bounded while enforcing a conversion-oriented slot mix.
    // Preferred output: 2 core + 1 utility + 1 margin.
    var maxCollectionsToQuery = Math.max(4, Math.min(12, Number(engine.maxCollectionsToQuery) || 8));
    collectionSpecs = orderCollectionSpecsForSlots(collectionSpecs, recommendationLimit).slice(0, maxCollectionsToQuery);

    debugLog(
      'collections to query',
      collectionSpecs.map(function (s) {
        return s.handle;
      })
    );

    var requireAvailable = engine.requireAvailable !== false;
    var maxPages = Math.max(1, Math.min(6, Number(engine.maxPages) || 2));

    var cartSet = new Set(cartProductIds.map(String));
    var out = [];
    var seen = new Set();
    var recentShownMap = getRecentlyShownMap();

    // Diversity: max 1 recommendation per collection handle. We already enforce
    // category diversity when building collectionSpecs; this keeps it deterministic.
    var fetchedByHandle = new Map();
    var rankCandidateIds = [];

    // Fetch all collections in parallel for speed.
    var fetchPromises = collectionSpecs.map(function (spec) {
      var path = '/collections/' + encodeURIComponent(spec.handle) + '/products.json';
      return fetchProductsFromEndpoint(path, signal, spec.limit, maxPages).catch(function (e) {
        debugLog('collection fetch error', { handle: spec.handle, error: String((e && e.message) || e) });
        return [];
      });
    });
    var fetchResults = await Promise.all(fetchPromises);

    for (var s = 0; s < collectionSpecs.length; s += 1) {
      var products = fetchResults[s] || [];
      var spec = collectionSpecs[s];
      var availCount = 0;
      for (var q = 0; q < products.length; q += 1) {
        if (isAvailable(products[q])) availCount += 1;
      }
      debugLog('collection fetched', { handle: spec.handle, total: products.length, available: availCount });
      fetchedByHandle.set(spec.handle, products);

      // Collect rank candidates (top of each collection only).
      for (var cIdx = 0; cIdx < Math.min(products.length, 24); cIdx += 1) {
        var pid = products[cIdx] && products[cIdx].id != null ? String(products[cIdx].id) : '';
        if (pid) rankCandidateIds.push(pid);
      }
    }

    // Attach sales_rank to fetched products when possible (metafield: soundtrap.sales_rank).
    // We only need this on a small window to pick one per collection.
    try {
      var dedup = Array.from(new Set(rankCandidateIds));
      var ranks = await fetchSalesRanksForProductIds(dedup, signal);
      if (ranks && ranks.size) {
        fetchedByHandle.forEach(function (list, handle) {
          for (var i = 0; i < list.length; i += 1) {
            var id = list[i] && list[i].id != null ? String(list[i].id) : '';
            if (!id) continue;
            if (!ranks.has(id)) continue;
            list[i].sales_rank = ranks.get(id) || 0;
          }
        });
        debugLog('sales_rank hydrated', { count: ranks.size });
      } else {
        debugLog('sales_rank hydrated', { count: 0 });
      }
    } catch (e) {
      debugLog('sales_rank hydrate failed', { error: String((e && e.message) || e) });
    }

    for (var hIdx = 0; hIdx < collectionSpecs.length; hIdx += 1) {
      if (out.length >= recommendationLimit) break;
      var handle = collectionSpecs[hIdx].handle;
      var list = fetchedByHandle.get(handle) || [];
      var best = pickBestCandidateFromCollection(handle, list, cartSet, seen, requireAvailable, cartProductTypes, cartTitles, cartHandles, recentShownMap);
      if (!best) continue;

      var variantId = pickVariantId(best);
      if (!variantId) continue;

      var id = String(best.id || '');
      if (id) seen.add(id);
      debugLog('picked from collection', { handle: handle, product: best.title });

      out.push({
        id: best.id,
        handle: best.handle,
        title: best.title,
        product_type: best.product_type || '',
        available: isAvailable(best),
        featured_image: pickImage(best),
        variants: [{ id: Number(variantId), price: coerceMoneyCents(best) / 100 }],
        price: coerceMoneyCents(best),
      });
    }

    // Safety: even rule collections can drift over time; never suggest instruments if an instrument is in-cart.
    out = filterFallbackProductsByCart(cartProductTypes || [], out);

    return out.slice(0, recommendationLimit);
  }

  function scoreProduct(product, sourceIndex) {
    var rank = typeof product.sales_rank === 'number' ? product.sales_rank : 0;
    var price = Number(product.price || 0);
    return rank + Math.max(0, 100000 - price) / 100000 - sourceIndex * 0.02;
  }

  async function getMergedRecommendations(cartProductIds, signal) {
    var all = [];
    var anchors = cartProductIds.slice(0, maxAnchorProducts);
    var settled = await Promise.allSettled(
      anchors.map(function (productId) {
        return fetchRecommendationsForProduct(productId, signal);
      })
    );

    for (var i = 0; i < settled.length; i += 1) {
      if (settled[i].status === 'rejected') {
        var reason = settled[i].reason;
        if (reason && reason.name === 'AbortError') throw reason;
        continue;
      }
      var recs = settled[i].value || [];
      for (var r = 0; r < recs.length; r += 1) {
        all.push({ product: recs[r], sourceIndex: i });
      }
    }

    var cartSet = new Set(cartProductIds.map(String));
    var deduped = new Map();

    for (var j = 0; j < all.length; j += 1) {
      var candidate = all[j].product;
      var id = String(candidate.id || '');
      if (!id || cartSet.has(id)) continue;
      if (!isAvailable(candidate)) continue;
      if (!candidate.variants || !candidate.variants.length) continue;

      var existing = deduped.get(id);
      var scored = {
        product: candidate,
        score: scoreProduct(candidate, all[j].sourceIndex),
      };

      if (!existing || scored.score > existing.score) {
        deduped.set(id, scored);
      }
    }

    return Array.from(deduped.values())
      .sort(function (a, b) {
        return b.score - a.score;
      })
      .slice(0, recommendationLimit)
      .map(function (entry) {
        return entry.product;
      });
  }

  function getCollectionHandleFromPath() {
    var match = window.location.pathname.match(/^\/collections\/([^/?#]+)/i);
    return match && match[1] ? decodeURIComponent(match[1]) : '';
  }

  function pickFallbackProducts(products, cartProductIds) {
    if (!products.length) return [];

    var cartSet = new Set(cartProductIds.map(String));
    var out = [];
    var seen = new Set();
    for (var i = 0; i < products.length; i += 1) {
      var p = products[i];
      var id = String(p.id || '');
      if (!id || seen.has(id) || cartSet.has(id)) continue;
      if (!isAvailable(p)) continue;
      if (!p.variants || !p.variants.length) continue;
      seen.add(id);
      out.push(p);
      if (out.length >= recommendationLimit) break;
    }
    return out;
  }

  function mergePrefetchedRecommendations(cartProductIds) {
    if (!cartProductIds || !cartProductIds.length) return [];

    var merged = [];
    var seen = new Set();
    for (var i = 0; i < cartProductIds.length; i += 1) {
      var prefetched = getPrefetchedRecommendationsForProduct(cartProductIds[i]);
      for (var j = 0; j < prefetched.length; j += 1) {
        var product = prefetched[j];
        var id = String((product && product.id) || '');
        if (!id || seen.has(id)) continue;
        seen.add(id);
        merged.push(product);
        if (merged.length >= recommendationLimit) return merged;
      }
    }
    return merged;
  }

  async function fetchCollectionFallback(cartProductIds, signal) {
    var handle = getCollectionHandleFromPath();
    if (!handle) return [];

    var path = '/collections/' + encodeURIComponent(handle) + '/products.json';
    var products = await fetchProductsFromEndpoint(path, signal, 60, 3);
    return pickFallbackProducts(products, cartProductIds);
  }

  async function fetchGlobalFallback(cartProductIds, signal) {
    var products = await fetchProductsFromEndpoint('/collections/all/products.json', signal, 60, 4);
    return pickFallbackProducts(products, cartProductIds);
  }

  async function fetchConfiguredFallbackCollections(cfg, cartProductIds, signal) {
    var fb = (cfg && cfg.fallback) || {};
    var cols = Array.isArray(fb.collections) ? fb.collections : [];
    if (!cols.length) return [];

    var engine = (cfg && cfg.engine) || defaultRulesConfig().engine;
    var maxPages = Math.max(1, Math.min(6, Number(engine.maxPages) || 2));

    var products = [];
    for (var i = 0; i < cols.length; i += 1) {
      var h = cols[i] && cols[i].handle ? normalizeText(cols[i].handle) : '';
      if (!h) continue;
      var lim = Math.max(24, Math.min(250, Number(cols[i].limit) || 60));
      try {
        var list = await fetchProductsFromEndpoint('/collections/' + encodeURIComponent(h) + '/products.json', signal, lim, maxPages);
        products = products.concat(list);
      } catch (e) {
        // ignore
      }
      if (products.length >= recommendationLimit * 4) break;
    }

    // Reuse existing picker (expects products.json shape).
    return pickFallbackProducts(products, cartProductIds);
  }

  function updateHeadingText(mode) {
    var container = getContainer();
    if (!container) return;
    var titleEl = container.querySelector('[data-reco-title]');
    var subtitleEl = container.querySelector('[data-reco-subtitle]');
    if (!titleEl && !subtitleEl) return;

    if (currentContext === 'product-page') {
      if (titleEl) titleEl.textContent = 'Recommended accessories';
      if (subtitleEl) subtitleEl.textContent = 'Essential add-ons for this product.';
    } else if (currentContext === 'cart-page') {
      if (titleEl) titleEl.textContent = 'Complete your setup';
      if (subtitleEl) subtitleEl.textContent = 'Popular add-ons for your order.';
    } else if (mode === 'accessory') {
      if (titleEl) titleEl.textContent = 'You might also like';
      if (subtitleEl) subtitleEl.textContent = 'Related items for your order.';
    } else {
      if (titleEl) titleEl.textContent = 'Customers also purchased';
      if (subtitleEl) subtitleEl.textContent = 'Popular add-ons for this setup.';
    }
  }

  function pauseAutoSlide() { autoSlidePaused = true; }

  function resumeAutoSlide() {
    autoSlidePaused = false;
    scheduleAutoSlideNext();
  }

  function resumeAutoSlideDelayed() {
    setTimeout(resumeAutoSlide, 1500);
  }

  function scheduleAutoSlideNext() {
    if (autoSlideTimer) clearTimeout(autoSlideTimer);
    autoSlideTimer = setTimeout(function () {
      if (autoSlidePaused || !autoSlideListNode) return;
      var children = autoSlideListNode.children;
      if (!children || children.length < 2) return;

      var scrollWidth = autoSlideListNode.scrollWidth;
      var clientWidth = autoSlideListNode.clientWidth;
      if (scrollWidth <= clientWidth) return;

      var maxScroll = scrollWidth - clientWidth;
      var currentScroll = autoSlideListNode.scrollLeft;

      if (currentScroll >= maxScroll - 2) {
        autoSlideListNode.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        var step = children.length > 1
          ? (children[1].offsetLeft - children[0].offsetLeft)
          : children[0].offsetWidth;
        var newLeft = Math.min(currentScroll + step, maxScroll);
        autoSlideListNode.scrollTo({ left: newLeft, behavior: 'smooth' });
      }

      scheduleAutoSlideNext();
    }, 3500);
  }

  function startAutoSlide(listNode) {
    stopAutoSlide();
    if (!listNode) return;
    autoSlideListNode = listNode;
    autoSlidePaused = false;
    listNode.addEventListener('mouseenter', pauseAutoSlide);
    listNode.addEventListener('mouseleave', resumeAutoSlide);
    listNode.addEventListener('touchstart', pauseAutoSlide, { passive: true });
    listNode.addEventListener('touchend', resumeAutoSlideDelayed);
    // Initial delay before first auto-scroll (let user see initial set first).
    scheduleAutoSlideNext();
  }

  function stopAutoSlide() {
    if (autoSlideTimer) { clearTimeout(autoSlideTimer); autoSlideTimer = null; }
    if (autoSlideListNode) {
      autoSlideListNode.removeEventListener('mouseenter', pauseAutoSlide);
      autoSlideListNode.removeEventListener('mouseleave', resumeAutoSlide);
      autoSlideListNode.removeEventListener('touchstart', pauseAutoSlide);
      autoSlideListNode.removeEventListener('touchend', resumeAutoSlideDelayed);
      autoSlideListNode = null;
    }
    autoSlidePaused = false;
  }

  function renderRecommendations(products) {
    var container = getContainer();
    var listNode = getListNode();
    if (!container || !listNode) return;

    try {
      products = sanitizeProducts(products);
      if (!products.length) {
        container.hidden = true;
        renderingNow = true;
        listNode.innerHTML = '';
        renderingNow = false;
        lastRenderedKey = '';
        stopAutoSlide();
        return;
      }

      var renderKey = products
        .map(function (product) {
          return String(product.id || '');
        })
        .join(',');
      if (renderKey === lastRenderedKey) {
        // Shopify can re-render the drawer HTML on cart changes, which wipes our injected list
        // while this JS module still holds the previous render key. Only skip if the DOM
        // already contains recommendation cards.
        try {
          if (listNode.children && listNode.children.length > 0) {
            container.hidden = false;
            return;
          }
        } catch (e) {
          // fall through to re-render
        }
      }
      lastRenderedKey = renderKey;

      var cards = products
        .map(function (product) {
          var variant = product.variants && product.variants[0];
          if (!variant || !variant.id) return '';
          var image = escapeHtml(pickImage(product));
          var title = escapeHtml(product.title || 'Recommended product');
          var href = '/products/' + encodeURIComponent(product.handle || '');

          return (
            '<article class="cart-drawer-recommendation">' +
            '<a href="' + href + '">' +
            (image
              ? '<img class="cart-drawer-recommendation__image" loading="lazy" src="' + image + '" alt="' + title + '">'
              : '') +
            '</a>' +
            '<p class="cart-drawer-recommendation__title">' + title + '</p>' +
            '<div class="cart-drawer-recommendation__price">' + formatPrice(product.price) + '</div>' +
            '<button class="cart-drawer-recommendation__button" type="button" data-reco-variant-id="' +
            variant.id +
            '">+ Add to cart</button>' +
            '</article>'
          );
        })
        .filter(Boolean)
        .join('');

      if (!cards) {
        container.hidden = true;
        renderingNow = true;
        listNode.innerHTML = '';
        renderingNow = false;
        lastRenderedKey = '';
        return;
      }

      renderingNow = true;
      listNode.innerHTML = cards;
      renderingNow = false;
      container.hidden = false;
      document.dispatchEvent(
        new CustomEvent('soundtrap:reco-impression', {
          detail: {
            context: 'cart_drawer',
            productIds: products.map(function (p) {
              return String(p.id || '');
            }),
          },
        })
      );
      startAutoSlide(listNode);
    } catch (e) {
      container.hidden = true;
      listNode.innerHTML = '';
      lastRenderedKey = '';
      stopAutoSlide();
    }
  }

  function renderVerticalCards(products) {
    var container = getContainer();
    var listNode = getListNode();
    if (!container || !listNode) return;

    try {
      products = sanitizeProducts(products);
      if (!products.length) {
        container.hidden = true;
        renderingNow = true;
        listNode.innerHTML = '';
        renderingNow = false;
        lastRenderedKey = '';
        stopAutoSlide();
        return;
      }

      var renderKey = products
        .map(function (product) {
          return String(product.id || '');
        })
        .join(',');
      if (renderKey === lastRenderedKey) {
        try {
          if (listNode.children && listNode.children.length > 0) {
            container.hidden = false;
            return;
          }
        } catch (e) {
          // fall through to re-render
        }
      }
      lastRenderedKey = renderKey;

      var cards = products
        .map(function (product) {
          var variant = product.variants && product.variants[0];
          if (!variant || !variant.id) return '';
          var image = escapeHtml(pickImage(product));
          var title = escapeHtml(product.title || 'Recommended product');
          var href = '/products/' + encodeURIComponent(product.handle || '');

          return (
            '<article class="st-reco-card">' +
            '<a href="' + href + '">' +
            (image
              ? '<img class="st-reco-card__image" loading="lazy" src="' + image + '" alt="' + title + '">'
              : '') +
            '</a>' +
            '<div class="st-reco-card__body">' +
            '<a href="' + href + '" class="st-reco-card__title">' + title + '</a>' +
            '<div class="st-reco-card__price">' + formatPrice(product.price) + '</div>' +
            '<button class="st-reco-card__button" type="button" data-reco-variant-id="' +
            variant.id +
            '">Add to cart</button>' +
            '</div>' +
            '</article>'
          );
        })
        .filter(Boolean)
        .join('');

      if (!cards) {
        container.hidden = true;
        renderingNow = true;
        listNode.innerHTML = '';
        renderingNow = false;
        lastRenderedKey = '';
        return;
      }

      renderingNow = true;
      listNode.innerHTML = cards;
      renderingNow = false;
      container.hidden = false;
      document.dispatchEvent(
        new CustomEvent('soundtrap:reco-impression', {
          detail: {
            context: currentContext || 'unknown',
            productIds: products.map(function (p) {
              return String(p.id || '');
            }),
          },
        })
      );
      if (currentContext !== 'cart-page') startAutoSlide(listNode);
    } catch (e) {
      container.hidden = true;
      listNode.innerHTML = '';
      lastRenderedKey = '';
      stopAutoSlide();
    }
  }

  function renderForContext(products) {
    if (currentContext === 'cart-page' || currentContext === 'product-page') {
      renderVerticalCards(products);
    } else {
      renderRecommendations(products);
    }
  }

  async function refreshRecommendations() {
    if (!isEnabled()) return;

    var container = getContainer();
    if (!container) return;

    // Instant fallback: if DOM was wiped (section re-render) but we have previous results
    // for the SAME cart, re-render immediately so recs never visually disappear.
    // Skip if cart changed — avoids flashing stale products on first load of a new cart.
    var quickCartKey = getCartProductIds().slice().sort().join(',');
    var listNode = getListNode();
    if (listNode && (!listNode.children || listNode.children.length === 0) && lastSuccessfulProducts.length && quickCartKey === lastSuccessfulCartKey) {
      debugLog('instant re-render from lastSuccessfulProducts', lastSuccessfulProducts.length);
      renderForContext(lastSuccessfulProducts);
    }

    // If a full pipeline is already running for the same cart, skip this call.
    // The instant fallback above already restored visibility.
    if (refreshRunning && quickCartKey === lastRefreshCartKey) {
      debugLog('skip duplicate refresh (pipeline already running for same cart)');
      return;
    }

    var cfg = await ensureRulesConfig();
    var maxLines = getMaxVisibleCartLines(cfg);

    var cartProductIds;
    var cartLineCount;
    var cartProductTypes;
    var cartTitles;
    var cartHandles;
    var cartSignals;

    // Product-page context: build cart data from the current product instead of the cart.
    if (currentContext === 'product-page') {
      var pd = window.ST_PRODUCT_RECO_DATA || {};
      cartProductIds = pd.productId ? [String(pd.productId)] : [];
      cartLineCount = 1;
      cartProductTypes = pd.productType ? [pd.productType] : [];
      cartTitles = pd.productTitle ? [pd.productTitle] : [];
      cartHandles = pd.productHandle ? [pd.productHandle] : [];
      cartSignals = uniqueStrings(cartProductTypes.concat(cartTitles));
      debugLog('signals(product-page)', { productIds: cartProductIds, productTypes: cartProductTypes, handles: cartHandles });
    } else {
      cartProductIds = getCartProductIds();
      cartLineCount = getCartLineCount();
      if (currentContext === 'cart-drawer') setDrawerLineCountAttr(cartLineCount);
      cartProductTypes = getCartProductTypes();
      cartTitles = getCartProductTitles();
      cartHandles = getCartProductHandles();
      cartSignals = uniqueStrings(cartProductTypes.concat(cartTitles));
      debugLog('signals(dom)', { lineCount: cartLineCount, productIds: cartProductIds, productTypes: cartProductTypes, handles: cartHandles });

      // Always merge a /cart.js snapshot: DOM can be stale after section re-render, and titles often omit "guitar".
      try {
        var snapshotMerge = await fetchCartSnapshotFromApi(activeController ? activeController.signal : undefined);
        if (snapshotMerge) {
          if (snapshotMerge.productIds && snapshotMerge.productIds.length) cartProductIds = snapshotMerge.productIds;
          cartLineCount = Number(snapshotMerge.lineCount) || cartLineCount;
          if (currentContext === 'cart-drawer') setDrawerLineCountAttr(cartLineCount);
          if (snapshotMerge.productTypes && snapshotMerge.productTypes.length) {
            cartProductTypes = uniqueStrings(cartProductTypes.concat(snapshotMerge.productTypes));
          }
          if (snapshotMerge.productTitles && snapshotMerge.productTitles.length) {
            cartTitles = uniqueStrings(cartTitles.concat(snapshotMerge.productTitles));
          }
        }
      } catch (e) {
        // best-effort only
      }

      if (!cartProductIds.length || !cartLineCount) {
        try {
          var snapshot = await fetchCartSnapshotFromApi(activeController ? activeController.signal : undefined);
          cartProductIds = snapshot.productIds;
          cartLineCount = snapshot.lineCount;
          if (currentContext === 'cart-drawer') setDrawerLineCountAttr(cartLineCount);
          if (snapshot.productTypes && snapshot.productTypes.length) {
            cartProductTypes = uniqueStrings(cartProductTypes.concat(snapshot.productTypes));
          }
        } catch (e) {
          cartProductIds = [];
          cartLineCount = 0;
          if (currentContext === 'cart-drawer') setDrawerLineCountAttr(0);
        }
      }
      cartSignals = uniqueStrings(cartProductTypes.concat(cartTitles));
      // If product types are missing for any reason, hydrate from handles (fast, deterministic).
      try {
        cartProductTypes = await hydrateCartProductTypesFromHandles(
          cartProductTypes,
          cartHandles,
          activeController ? activeController.signal : undefined
        );
      } catch (e) {
        // ignore
      }
      debugLog('signals(after hydrate)', { productTypes: cartProductTypes, titles: cartTitles });
    }

    var accessoryOnly = isAccessoryOnlyCart(cartProductTypes);
    debugLog('accessoryOnly', accessoryOnly);

    if (!cartProductIds.length) {
      lastSuccessfulProducts = [];
      lastSuccessfulCartKey = '';
      container.hidden = true;
      return;
    }
    if (currentContext === 'cart-drawer' && cartLineCount > maxLines) {
      container.hidden = true;
      return;
    }
    // Don't pre-hide based on estimated heights. This was causing "no recs" even when we
    // had room. We'll instead render, then hide only if we detect actual overlap.

    var cacheKey = getCacheKey(cartProductIds);
    var cachedProducts = getCachedRecommendations(cacheKey);
    if (!cachedProducts.length) {
      // Only use prefetched Shopify algo recs when the rule engine is NOT active.
      // Otherwise stale "similar product" results (e.g. more guitars) bleed through.
      var hasRules = cfg && cfg.rules && cfg.rules.length;
      if (!hasRules) {
        cachedProducts = mergePrefetchedRecommendations(cartProductIds);
      }
    }
    cachedProducts = sanitizeProducts(cachedProducts);
    var hasCachedProducts = cachedProducts.length > 0;
    if (hasCachedProducts) {
      updateHeadingText(accessoryOnly ? 'accessory' : 'instrument');
      renderForContext(cachedProducts);
      setCachedRecommendations(cacheKey, cachedProducts);
      lastSuccessfulProducts = cachedProducts.slice();
      lastSuccessfulCartKey = cacheKey;
      if (currentContext === 'cart-drawer') updateLastKnownRecsHeight();
      if (currentContext === 'cart-drawer') enforceNoOverlap(cartLineCount, maxLines);
      // Don't re-run the pipeline when cache exists. Random picks in the pipeline
      // produce different products each time, which causes render→observer→refresh loops.
      // Variety comes from new carts (different cacheKey) or new sessions (cleared sessionStorage).
      return;
    }

    var token = refreshToken + 1;
    refreshToken = token;
    refreshRunning = true;
    lastRefreshCartKey = cartProductIds.slice().sort().join(',');
    if (!hasCachedProducts && !lastSuccessfulProducts.length) {
      setLoadingState(true);
    }
    if (activeController) {
      activeController.abort();
    }
    activeController = new AbortController();

    try {
      var products;

      if (accessoryOnly) {
        // Accessory-only cart: infer instrument family from titles, fetch companion accessories.
        debugLog('accessory-only pipeline');
        var inferredFamilies = inferFamilyFromTitles(cartTitles.concat(cartProductTypes).concat(cartHandles));
        debugLog('inferred families', Array.from(inferredFamilies));
        if (inferredFamilies.size) {
          var accHandles = getFamilyFallbackHandles(inferredFamilies);
          var cartSet = new Set((cartProductIds || []).map(String));
          var accOut = [];
          var accSeen = new Set();
          for (var ah = 0; ah < accHandles.length; ah += 1) {
            if (accOut.length >= recommendationLimit) break;
            try {
              var accList = await fetchProductsFromEndpoint('/collections/' + encodeURIComponent(accHandles[ah]) + '/products.json', activeController.signal, 60, 1);
              for (var ap = 0; ap < accList.length; ap += 1) {
                if (accOut.length >= recommendationLimit) break;
                var accProd = accList[ap];
                var accId = String((accProd && accProd.id) || '');
                if (!accId || accSeen.has(accId) || cartSet.has(accId)) continue;
                if (!isAvailable(accProd)) continue;
                if (!accProd.variants || !accProd.variants.length) continue;
                var accVarId = pickVariantId(accProd);
                if (!accVarId) continue;
                accSeen.add(accId);
                accOut.push({
                  id: accProd.id,
                  handle: accProd.handle,
                  title: accProd.title,
                  product_type: accProd.product_type || '',
                  available: isAvailable(accProd),
                  featured_image: pickImage(accProd),
                  variants: [{ id: Number(accVarId), price: coerceMoneyCents(accProd) / 100 }],
                  price: coerceMoneyCents(accProd),
                });
              }
            } catch (accErr) {
              // ignore individual collection errors
            }
          }
          products = accOut.slice(0, recommendationLimit);
        } else {
          products = [];
        }
        products = sanitizeProducts(products);
        debugLog('accessory-only results', products.length);
      } else {
        // Normal instrument-in-cart pipeline.
        var attemptedFamilyFallback = false;
        products = await getRuleBasedRecommendations(cfg, cartProductIds, cartProductTypes, activeController.signal, cartTitles, cartHandles);
        debugLog('rule-based results (before filter)', products.length, products.map(function (p) { return { id: p.id, title: p.title, type: p.product_type, available: isAvailable(p) }; }));
        products = filterFallbackProductsByCart(cartSignals, products);
        products = sanitizeProducts(products);
        debugLog('rule-based results (after filter)', products.length);

        if (!products.length && !attemptedFamilyFallback) {
          debugLog('trying family fallback');
          products = await fetchFamilyFallbackRecommendations(cartProductIds, cartSignals, activeController.signal);
          attemptedFamilyFallback = true;
          products = sanitizeProducts(products);
          debugLog('family fallback results', products.length);
        }

        if (!products.length && cfg && cfg.fallback && cfg.fallback.collections && cfg.fallback.collections.length) {
          products = await fetchConfiguredFallbackCollections(cfg, cartProductIds, activeController.signal);
          products = filterFallbackProductsByCart(cartSignals, products);
          products = sanitizeProducts(products);
        }
        if (!products.length && cfg && cfg.fallback && cfg.fallback.useShopifyRecommendations !== false) {
          products = await getMergedRecommendations(cartProductIds, activeController.signal);
          products = await hydrateMissingProductTypes(products, cartSignals, activeController.signal);
          products = filterFallbackProductsByCart(cartSignals, products);
          products = sanitizeProducts(products);
        }
        if (!products.length && !attemptedFamilyFallback) {
          products = await fetchFamilyFallbackRecommendations(cartProductIds, cartSignals, activeController.signal);
          attemptedFamilyFallback = true;
          products = sanitizeProducts(products);
        }
      }

      if (token !== refreshToken) { refreshRunning = false; return; }
      setLoadingState(false);
      debugLog('final products to render', products.length, products.map(function (p) { return (p && p.title) || '?'; }));
      // Never replace an already-rendered set with "nothing" (causes flicker where
      // recs appear briefly, then disappear if a later refresh yields 0 products).
      if (!products.length && hasCachedProducts) {
        debugLog('keeping cached recs (rule engine returned 0)');
        if (currentContext === 'cart-drawer') updateLastKnownRecsHeight();
        if (currentContext === 'cart-drawer') enforceNoOverlap(cartLineCount, maxLines);
        refreshRunning = false;
        return;
      }
      if (products.length) {
        markProductsRecentlyShown(products);
        setCachedRecommendations(cacheKey, products);
        lastSuccessfulProducts = products.slice();
        lastSuccessfulCartKey = cacheKey;
      } else {
        // Clear stale lastSuccessfulProducts so the instant-re-render path at the top
        // of refreshRecommendations doesn't keep re-rendering old products for a cart
        // that genuinely has no recommendations (prevents observer→refresh loop).
        lastSuccessfulProducts = [];
        lastSuccessfulCartKey = '';
      }
      updateHeadingText(accessoryOnly ? 'accessory' : 'instrument');
      renderForContext(products);
      if (currentContext === 'cart-drawer') updateLastKnownRecsHeight();
      if (currentContext === 'cart-drawer') enforceNoOverlap(cartLineCount, maxLines);
      refreshRunning = false;
    } catch (error) {
      refreshRunning = false;
      if (error && error.name === 'AbortError') {
        setLoadingState(false);
        return;
      }
      setLoadingState(false);
      if (!hasCachedProducts) {
        container.hidden = true;
      }
    }
  }

  function scheduleRefresh(delayMs) {
    if (refreshTimer) {
      clearTimeout(refreshTimer);
    }
    refreshTimer = setTimeout(function () {
      refreshRecommendations();
    }, typeof delayMs === 'number' ? delayMs : 120);
  }

  function findProductIdFromTarget(target) {
    if (!(target instanceof HTMLElement)) return '';
    var productNode = target.closest('[data-product-id]');
    if (productNode) {
      var id = productNode.getAttribute('data-product-id');
      if (id) return String(id);
    }
    return '';
  }

  async function prefetchRecommendationsForProduct(productId) {
    if (!productId) return;
    // When the rule engine has rules configured, skip Shopify algorithmic prefetch.
    // The rule engine will handle recommendations when the cart drawer opens.
    // Prefetching from Shopify's /recommendations API returns similar products
    // (e.g. more guitars) instead of accessories, which then persist via the
    // "never replace cached with nothing" logic even after the rule engine runs.
    if (rulesConfig && rulesConfig.rules && rulesConfig.rules.length) {
      debugLog('prefetch skipped (rule engine active)');
      return;
    }
    if (prefetchInflight.has(productId)) return;
    if (getPrefetchedRecommendationsForProduct(productId).length) return;

    var task = (async function () {
      try {
        var products = await fetchRecommendationsForProduct(productId);
        if (!products.length) {
          products = await fetchGlobalFallback([String(productId)]);
        }
        if (!products.length) return;
        setPrefetchedRecommendationsForProduct(String(productId), products);
      } catch (e) {
        // Keep prefetch best-effort only.
      } finally {
        prefetchInflight.delete(productId);
      }
    })();

    prefetchInflight.set(productId, task);
  }

  async function addVariantToCart(variantId, button) {
    if (!variantId) return;
    if (button) button.disabled = true;

    try {
      var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';
      var response = await fetch(addUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
      });

      if (!response.ok) {
        throw new Error('Failed to add recommendation item');
      }

      if (currentContext === 'cart-drawer') {
        var drawerItems = document.querySelector('cart-drawer-items');
        if (drawerItems && typeof drawerItems.onCartUpdate === 'function') {
          await drawerItems.onCartUpdate();
        }
      } else if (currentContext === 'cart-page') {
        var cartItems = document.querySelector('cart-items');
        if (cartItems && typeof cartItems.onCartUpdate === 'function') {
          await cartItems.onCartUpdate();
        }
        // Also refresh the cart footer (totals) via section rendering
        try {
          var sections = 'main-cart-footer';
          var footerRes = await fetch(
            window.location.pathname + '?sections=' + encodeURIComponent(sections),
            { credentials: 'same-origin', headers: { Accept: 'application/json' } }
          );
          if (footerRes.ok) {
            var footerJson = await footerRes.json();
            Object.keys(footerJson).forEach(function (key) {
              var el = document.getElementById('shopify-section-' + key);
              if (el && footerJson[key]) el.innerHTML = new DOMParser().parseFromString(footerJson[key], 'text/html').body.innerHTML;
            });
          }
        } catch (e) {
          // best effort
        }
      }
      // product-page: no cart UI to update; events handle it

      document.dispatchEvent(new CustomEvent('soundtrap:cart-updated'));
      document.dispatchEvent(
        new CustomEvent('soundtrap:reco-add', {
          detail: { context: currentContext || 'cart_drawer', variantId: String(variantId) },
        })
      );
    } catch (error) {
      console.warn('[cart-recommendations] add to cart failed', error);
    } finally {
      if (button) button.disabled = false;
    }
  }

  function bindEvents() {
    if (document.body.dataset.cartRecoBound === '1') return;
    document.body.dataset.cartRecoBound = '1';

    document.addEventListener('soundtrap:cart-updated', function () {
      scheduleRefresh(140);
    });

    if (currentContext === 'cart-drawer') {
      document.addEventListener('soundtrap:cart-drawer-rendered', function () {
        scheduleRefresh(100);
      });
    }

    document.addEventListener('cart:updated', function () {
      scheduleRefresh(80);
    });

    if (currentContext === 'cart-drawer') {
      document.addEventListener('change', function (event) {
        var target = event.target;
        if (!(target instanceof HTMLElement)) return;
        if (target.matches('#CartDrawer-CartItems input[name="updates[]"]')) {
          scheduleRefresh(120);
        }
      });

      var cartIcon = document.getElementById('cart-icon-bubble');
      if (cartIcon) {
        cartIcon.addEventListener('click', function () {
          scheduleRefresh(120);
        });
      }
    }

    document.addEventListener('click', function (event) {
      var target = event.target;
      if (!(target instanceof HTMLElement)) return;
      if (!target.matches('[data-reco-variant-id]')) return;
      event.preventDefault();
      addVariantToCart(target.getAttribute('data-reco-variant-id'), target);
    });

    document.addEventListener('click', function (event) {
      var target = event.target;
      if (!(target instanceof HTMLElement)) return;
      var addButton = target.closest('button[name="add"], .quick-add__submit, .product-form__submit');
      if (!(addButton instanceof HTMLElement)) return;
      if (addButton.matches('[data-reco-variant-id]')) return;
      var productId = findProductIdFromTarget(addButton);
      if (productId) {
        prefetchRecommendationsForProduct(productId);
      }
    });

    window.addEventListener('resize', function () {
      scheduleRefresh(60);
    });
  }

  function bindObservers() {
    if (observerBound) return;
    observerBound = true;

    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof MutationObserver !== 'undefined') {
      var drawerObserver = new MutationObserver(function (mutations) {
        // Ignore mutations caused by our own rendering.
        if (renderingNow) return;

        var hasAttribute = false;
        var hasChildList = false;
        for (var i = 0; i < mutations.length; i += 1) {
          if (mutations[i].type === 'attributes') hasAttribute = true;
          if (mutations[i].type === 'childList') hasChildList = true;
        }

        // Attribute change (e.g. class toggle for drawer open/close) — always refresh.
        if (hasAttribute) {
          scheduleRefresh(120);
          return;
        }

        // childList change — only react if our recs were actually wiped (section re-render).
        if (hasChildList) {
          var listNode = getListNode();
          var recsWiped = !listNode || !listNode.children || listNode.children.length === 0;
          if (recsWiped) {
            // Instant fallback from memory, then schedule full refresh.
            if (lastSuccessfulProducts.length) {
              renderRecommendations(lastSuccessfulProducts);
            }
            scheduleRefresh(200);
          }
          // If recs are still in the DOM, it was a benign DOM change — do nothing.
        }
      });
      drawerObserver.observe(drawer, { childList: true, subtree: true, attributeFilter: ['class'] });
    }
  }

  function startWarmRetries() {
    var attempts = 0;
    if (retryTimer) clearInterval(retryTimer);
    retryTimer = setInterval(function () {
      attempts += 1;
      scheduleRefresh(30);
      if (attempts >= 3) {
        clearInterval(retryTimer);
        retryTimer = null;
      }
    }, 500);
  }

  function init() {
    if (!isEnabled()) return;
    currentContext = detectContext();
    if (!currentContext) return;

    var rawLimit = Number(window.ST_CART_RECO_LIMIT || 4);
    recommendationLimit = Number.isNaN(rawLimit) ? 4 : Math.max(2, Math.min(8, rawLimit));
    if (currentContext === 'product-page') {
      recommendationLimit = Math.max(recommendationLimit, 6);
    } else if (currentContext === 'cart-page') {
      recommendationLimit = Math.max(recommendationLimit, 8);
    }

    ensureRulesConfig();
    bindEvents();
    if (currentContext === 'cart-drawer') bindObservers();
    scheduleRefresh(currentContext === 'cart-drawer' ? 60 : 200);
    if (currentContext === 'cart-drawer') startWarmRetries();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
